function hideNegatives() {
  $(".Pagination__item").attr("style", "display: block");
  $(".Pagination__item").each(function (i, obj) {
    if (i == 0) {
      if ($(obj).text() == "...") {
        $(obj).attr("style", "display: none !important");
      }
    }

    if ($(obj).text() <= 0) {
      $(obj).attr("style", "display: none !important");
    }
  });
}

$(document).ready(function () {
  
  $(".search-form form").submit(function(event) {
    var org = $(this).find("#search-input2").val();
    var tmp = "'" + org + "'";
    $(this).find("#search-input2").val(tmp);
    event.preventDefault();
    this.submit(); 
    $(this).find("#search-input2").val(org);
  });
  
  $(".fancybox").fancybox();

  $("body").on(
    "click",
    '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
    function () {
      if ($("#agree").is(":checked")) {
        $(this).submit();
      } else {
        alert(
          'Please review your order details and then check the box above the "Check Out" button.'
        );
        return false;
      }
    }
  );

  $("body").on("click", "#ReviewsWidget .RatingStatistics__text", function () {
    $("#ReviewsWidget .ListContent").toggle();
    hideNegatives();
  });

  $("body").on("click", ".Pagination__item", function () {
    hideNegatives();
    setTimeout(function () {
      hideNegatives();
    }, 1000);
  });

  function sortUL(selector) {
    $(selector)
      .children("li")
      .sort(function (a, b) {
        var upA = $(a).text().toUpperCase();
        var upB = $(b).text().toUpperCase();
        return upA < upB ? -1 : upA > upB ? 1 : 0;
      })
      .appendTo(selector);
  }
  sortUL("ul.mylist");

  function refreshProductHeights() {
    $(".product-title").matchHeight({});
    $(".product-meta").matchHeight({});
  }
  
  $(document).ready(function() {    
    // Set up a MutationObserver to watch for the ratings being inserted
    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length && 
              $(mutation.addedNodes).find('.ruk_rating_snippet').length || 
              $(mutation.target).find('.ruk_rating_snippet[data-done="true"]').length) {
            // Give a small delay to ensure content is fully rendered
            setTimeout(refreshProductHeights, 100);
          }
        });
      });
      
      // Start observing product containers
      const containers = document.querySelectorAll('.product-meta');
      containers.forEach(function(container) {
        observer.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-done'] });
      });
    }
    
    // Fallback approach - periodically check for 5 seconds after page load
    let checkCount = 0;
    const checkInterval = setInterval(function() {
      if ($('.ruk_rating_snippet[data-done="true"]').length > 0) {
        refreshProductHeights();
        clearInterval(checkInterval);
      }
      
      checkCount++;
      if (checkCount >= 10) {  // Stop checking after ~5 seconds
        clearInterval(checkInterval);
      }
    }, 500);
  });

  $(".opens").hide();
  $(".cilk").click(function () {
    $(this).next().slideToggle();
    $(this).closest(".question_head").siblings().find(".opens").slideUp();
    $(this)
      .closest(".question_head")
      .siblings()
      .find(".cilk")
      .removeClass("rotate");
    $(this).toggleClass("rotate");
  });

  //   homepage product slider

  $(".product-slider").slick({
    dots: false,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 789,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 490,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  //All Our Tree Gifts page slider
  //   $('#page-all-our-tree-gifts .collection-th').slick({
  //     dots: false,
  //     infinite: false,
  //     arrows:true,
  //     speed: 300,
  //     slidesToShow: 4,
  //     slidesToScroll: 1,
  //     responsive: [
  //       {
  //         breakpoint: 1450,
  //         settings: {
  //           slidesToShow: 4,
  //           slidesToScroll: 1,
  //           infinite: true,
  //           dots: true
  //         }
  //       },
  //       {
  //         breakpoint: 1050,
  //         settings: {
  //           slidesToShow: 3,
  //           slidesToScroll: 1
  //         }
  //       },
  //       {
  //         breakpoint: 789,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 1
  //         }
  //       },
  //       {
  //         breakpoint: 490,
  //         settings: {
  //           slidesToShow: 1,
  //           slidesToScroll: 1
  //         }
  //       }
  //     ]
  //   })

  //   product page main slider js

  $(".product-main-image").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    speed: 300,
    arrows: true,
    fade: true,
    infinite: true,
    adaptiveHeight: true,
    asNavFor: ".thumbnail-images",
  });

  $(".thumbnail-images").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product-main-image",
    arrows: false,
    adaptiveHeight: true,
    focusOnSelect: true,
    infinite: true,
  });

  $("#show-menu").on("click", function (e) {
    $("body").toggleClass("Navigation-open");
    e.preventDefault();
  });

  $(".lgx-mobile-nav-overlay").on("click", function() {
    $("body").removeClass("Navigation-open");
  });

  jQuery(".same-height").each(function () {
    function e() {
      jQuery(".same-height").css("height", "auto");
      var e = -1;
      jQuery(".same-height").each(function () {
        var t = jQuery(this).outerHeight();
        e = t > e ? t : e;
      }),
        jQuery(".same-height").css("height", e);
    }
    jQuery(this), jQuery(window).on("load resize orientationchange", e);
  });
});

// homepage blog equal heigh js
$.fn.equalHeights = function () {
  var max_height = 0;
  $(this).each(function () {
    max_height = Math.max($(this).height(), max_height);
  });
  $(this).each(function () {
    $(this).height(max_height);
  });
};
$(document).ready(function () {
  $(".article-title").equalHeights();
});

// custom pages images equal height

$.fn.equalHeights = function () {
  var max_height = 0;
  $(this).each(function () {
    max_height = Math.max($(this).height(), max_height);
  });
  $(this).each(function () {
    $(this).height(max_height);
  });
};

$(document).ready(function () {
  $(".equal-height").equalHeights();
  $("img").lazyload();
});

// $(document).ready(function() {
//   $(".set > a").on("click", function() {
//     if ($(this).hasClass("active")) {
//       $(this).removeClass("active");
//       $(this)
//         .siblings(".content")
//         .slideUp(200);
//       $(".set > a i")
//         .removeClass("fa-minus")
//         .addClass("fa-plus");
//     } else {
//       $(".set > a i")
//         .removeClass("fa-minus")
//         .addClass("fa-plus");
//       $(this)
//         .find("i")
//         .removeClass("fa-plus")
//         .addClass("fa-minus");
//       $(".set > a").removeClass("active");
//       $(this).addClass("active");
//       $(".content").slideUp(200);
//       $(this)
//         .siblings(".content")
//         .slideDown(200);
//     }
//   });
// });

// if ($(window).width() >= 1050) {
//   $('.menu-link').hover(function(){
//     $(this).find('ul').first().stop().toggle(200);
//   }, function(){
//     $(this).find('ul').stop().hide(200);
//   });
// }

// if ($('.menu-link').has('ul').length) {
//     $('.menu-link').click(function(e) {
//       e.preventDefault(); // Prevent default action
//       $(this).find('ul').first().toggle(); // Toggle the visibility of the ul
//     });
//   }

function updateMenuBehavior() {
  if ($(window).width() >= 1050) {
    $(".menu-link").off("click");
    $(".menu-link").hover(
      function () {
        $(this).find("ul").first().stop().toggle(200);
      },
      function () {
        $(this).find("ul").stop().hide(200);
      }
    );
  } else {
    // Remove hover events for smaller screens
    $(".menu-link").off("mouseenter mouseleave");
    $(".menu-link.has-sub-menu").on("click", function (e) {
      if ($(e.target).closest(".menu-link.has-sub-menu").is(this)) {
        // Ensure the click is on the .menu-link element itself
        e.preventDefault();
        $(this).toggleClass("has-sub-menu-open");
        $(this).children("ul").first().toggle();
      }
    });

    $(".menu-link.has-sub-menu ul").on("click", "li", function (e) {
      e.stopPropagation(); // Prevent the click event from bubbling up to the .menu-link.has-sub-menu
    });
  }
}

// Initial call to set up the appropriate behavior
updateMenuBehavior();

// Update behavior on window resize
$(window).resize(function () {
  updateMenuBehavior();
});

function customPopup() {
  var btnShowPopup = $(".js-open-popup");
  var btnClosePopup = $(".js-close-popup");
  var popup = $(".js-custom-popup");

  btnShowPopup.on("click", function () {
    var targetPopup = $(this).attr("data-target");
    $("[data-popup=" + targetPopup + "]").addClass("is-active");
  });

  btnClosePopup.on("click", function () {
    $(this).parents(".is-active").removeClass("is-active");
  });

  popup.on("click", function (event) {
    if (
      !$(event.target).closest(".js-custom-popup-holder").length &&
      !$(event.target).is("js-custom-popup")
    ) {
      if ($popup.hasClass("is-active")) {
        popup.removeClass("is-active");
      }
    }
  });
}

$(document).ready(function () {
  customPopup();
});
